export const theme = {
    colors: {
        white: "#FFFFFF",
        mercury: "#E5E5E5",
        mystic: "#E4E6F0",
        pattensBlue: "#D6E4FF",
        waterloo: "#7E839A",
        stormGray: "#74788B",
        silver: "#C4C4C4",
        mineShaft: "#333333",
        woodsmoke: "#18181B",
        black: "#000000",
        blue: "#0044CC",
    },

    breakpoints: {
        mobileTiny: 349,
        mobileMin: 467,
        mobileMed: 524,
        mobileMedium: 605,
        mobileMax: 767,
        tablet: 856,
        medium: 991,
        large: 1081,
        desktop: 1224,
        widest: 1440,
    },

    boxShadow: "0px 4px 12px rgba(186, 199, 213, 0.5)",
    hoverShadow: "0px 4px 12px rgba(11, 106, 194, 0.65);",
    activeShadow: "0px 4px 12px rgba(11, 106, 194, 0.75);",
};